// api/appVersion.js
import axios from '@/api'
import { Capacitor } from '@capacitor/core'
import { APP_VERSION } from '@/version'

/**
 * 获取当前APP版本号
 * 从构建时生成的常量文件读取
 */
export const getCurrentVersion = async () => {
  console.log('📱 当前APP版本:', APP_VERSION)
  return APP_VERSION
}

/**
 * 获取当前平台
 */
export const getPlatform = () => {
  if (window.Capacitor) {
    return Capacitor.getPlatform() // 'ios' 或 'android'
  }
  // 开发环境返回 ios
  return 'ios'
}

/**
 * 检查APP版本更新
 * @param {string} appType - 端类型：customer-客户端, manage-管理版
 * @param {string} platform - 平台：ios/android
 * @param {string} currentVersion - 当前版本号
 */
export const checkVersion = (appType, platform, currentVersion) => {
  return axios.get('/app/version/check', {
    params: { appType, platform, currentVersion }
  }).then(res => res.data)
}

/**
 * 一键检查版本更新（自动获取当前版本和平台）
 */
export const checkVersionAuto = async (appType = 'customer') => {
  const platform = getPlatform()
  const currentVersion = await getCurrentVersion()
  return checkVersion(appType, platform, currentVersion)
}
